import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
// import { element } from 'protractor';
// import { count } from 'rxjs/operators';

import { ReturnAllDateComponent } from '../return-all-date/return-all-date.component';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.css']
})
export class InvoiceListComponent implements OnInit {

  menu_id = '1';
  public menu_item_id = '12';
  public add_auth;
  public edit_auth;
  public del_auth;

  model = {
    'table_name': 'invoice', 'fromDate': new Date(), 'toDate': new Date(), 'invoice_no': '', 'customer_name': '',
    'mobile': '', 'inv_type': '0', 'inv_status': '0', 'branch_id': '0', 'store_id': '0', 'user_name': 'all', 
    'title': 'قائمة الفواتير'
  };

  // typeList = [{ 'type_id': '0', 'type_name': 'الكل', 'type_name_en': 'All' },
  // { 'type_id': '1', 'type_name': 'فواتير', 'type_name_en': 'Invoices' },
  // { 'type_id': '2', 'type_name': 'مرتجعات', 'type_name_en': 'Returns' }];

  statusList = [{ 'status_id': '0', 'status_name': 'الكل', 'status_name_en': 'All' },
    { 'status_id': '1', 'status_name': 'تم التسليم', 'status_name_en': 'Delivered' },
    { 'status_id': '2', 'status_name': 'لم يتم التسليم', 'status_name_en': 'Not Delivered' },
    { 'status_id': '3', 'status_name': 'مرجعة بالكامل', 'status_name_en': 'Fully Returned' }];

  private dp = [];
  displayedColumns = ['invoice_id', 'invoice_no', 'invoice_date', 'customer_name', 'mobile', 'final_total', 'payment_method',
    'created_by', 'branch_name', 'inv_status', 'detail', 'print', 'copy', 'return', 'del']; // , 'inv_type' 'edit',

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  displayedColumns2 = ['invoice_id', 'invoice_no', 'invoice_date', 'customer_name', 'mobile', 'final_total', 'payment_method',
    'created_by', 'branch_name', 'inv_status'];  // , 'inv_type'
  // private inv_list = [];

  branchList = [];
  allStoreList = [];
  storeList = [{ 'store_id': '0', 'store_name': 'الكل', 'store_name_en': 'All' }];
  users = [];

  from_date;
  to_date;
  total = 0;

  returnDateDialogRef: MatDialogRef<ReturnAllDateComponent>;

  From_Date; To_Date; Invoice_List; Branch; Store;
  Inv; Success_Msg; Error_Msg; Invoice_No;
  Customer_Name; Type; Mobile; Status; Search_Msg; Ret_No_Msg;
  Cancel_Invoice_Msg; Ret_All_Msg; Amount_Total;
  // Branch_Msg; Del_Msg; 


  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private route: ActivatedRoute, private router: Router, 
    public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Invoice_List').subscribe((res: string) => {
      this.Invoice_List = res;
    });
    this.model['title'] = this.Invoice_List;

    translate.get('Inv').subscribe((res: string) => {
      this.Inv = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
    
    translate.get('Ret_All_Msg').subscribe((res: string) => {
      this.Ret_All_Msg = res;
    });

    translate.get('Invoice_No').subscribe((res: string) => {
      this.Invoice_No = res;
    });

    translate.get('Customer_Name').subscribe((res: string) => {
      this.Customer_Name = res;
    });

    translate.get('Type').subscribe((res: string) => {
      this.Type = res;
    });

    translate.get('Mobile').subscribe((res: string) => {
      this.Mobile = res;
    });

    translate.get('Status').subscribe((res: string) => {
      this.Status = res;
    });

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });

    translate.get('Branch').subscribe((res: string) => {
      this.Branch = res;
    });

    translate.get('Store').subscribe((res: string) => {
      this.Store = res;
    });

    translate.get('Ret_No_Msg').subscribe((res: string) => {
      this.Ret_No_Msg = res;
    });

    translate.get('Cancel_Invoice_Msg').subscribe((res: string) => {
      this.Cancel_Invoice_Msg = res;
    });
    
    translate.get('Amount_Total').subscribe((res: string) => {
      this.Amount_Total = res;
    });
  }


  ngOnInit() {
    let href = this.router.url;
    let urlParts = href.split("/");
    this.menu_id = urlParts[2];

    if (this.menu_id == '12') 
      this.menu_item_id = '83';

    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    // this.from_date = (this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
    //   this.model['fromDate'].getDate());
    // this.to_date = (this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
    //   this.model['toDate'].getDate());

    // this.model['toDate'] = undefined;
    // this.model['fromDate'] = undefined;

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

    query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'" +
      " AND `branch_auth`.`store_id` = `store`.`store_id`";

    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.allStoreList = data.data['list'];
      });

    let condition = '';
    if (this.applicationConstants.user_info['user_name'] != 'mas')
      condition += " AND `user`.`user_name` != 'mas'";

    query = "SELECT `user`.`user_id`, `employee`.`name`, `employee`.`name_en`, `user`.`user_name`, `employee`.`employee_no`" +
      " FROM `user`, `employee` WHERE `user`.`status` = '1' AND `employee`.`employee_no` = `user`.`employee_no`" + condition;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        this.users = data.data['list'];
        this.users.unshift({ 'user_name': 'all', 'name': 'الكل', 'name_en': 'All' });
      });

    if (this.route.snapshot.paramMap.get("customer_id") != null) {
      this.model['customer_name'] = this.route.snapshot.paramMap.get("customer_name");
      let date = '01/01/' + this.model['fromDate'].getFullYear();
      this.model['fromDate'] = new Date(date);
      this.search();
    }
  }

  filterStore() {
    this.storeList = [{ 'store_id': '0', 'store_name': 'الكل', 'store_name_en': 'All' }];
    this.model['store_id'] = '0';

    if (this.model['branch_id'] != '0') {
      this.allStoreList.forEach(element => {
        if (element.branch_id == this.model['branch_id'])
          this.storeList.push(element);
      });
    }
  }

  search() {
    // this.inv_list = [];
    this.dp = [];
    this.total = 0;

    if ((this.model['fromDate'] == undefined || this.model['toDate'] == undefined) &&
      this.model['invoice_no'] == '') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getSaleInvoiceList' };  

    if (this.model['invoice_no'] != '') {
      obj['invoice_no'] = this.model['invoice_no'];
      obj['store_list'] = this.allStoreList;
    }
    else {
      if (this.model['fromDate'] != undefined) {
        this.from_date = this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) +
          "-" + this.model['fromDate'].getDate() + ' 00:00:00';
        obj['from_date'] = this.from_date;
      }

      if (this.model['toDate'] != undefined) {
        this.to_date = this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) +
          "-" + this.model['toDate'].getDate() + ' 23:59:59';
        obj['to_date'] = this.to_date;
      }

      if (this.model['inv_status'] != '0')
        obj['inv_status'] = this.model['inv_status'];

      if (this.model['customer_name'] != '')
        obj['customer_name'] = this.model['customer_name'];

      if (this.model['mobile'] != '')
        obj['mobile'] = this.model['mobile'];

      if (this.model['branch_id'] == '0')
        obj['store_list'] = this.allStoreList;
      else {
        if (this.model['store_id'] != '0')
          obj['store_id'] = this.model['store_id'];
        else {
          let allStoreList = [];
          this.storeList.forEach(element => {
            if (element.store_id != '0')
              allStoreList.push({ 'store_id': element.store_id });
          });
          obj['store_list'] = allStoreList;
        }
      }

      if (this.model['user_name'] != 'all')
        obj['user_name'] = this.model['user_name'];
    }

    if (this.menu_id == '12') 
      obj['type'] = 'maint';


    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.status['msg'][0]['list'];
        this.total = data.status['msg'][0]['total'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  print(invoice_no = null) {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    if (invoice_no == null) {
      let from_date = this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
        this.model['fromDate'].getDate();

      let to_date = this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
        this.model['toDate'].getDate();

      html_data = '<table cellpadding="8" cellspacing="0"><tr>';
      html_data += '<td width="33%"> ' + this.From_Date + ': ' + from_date + '</td>';
      html_data += '<td width="33%">  ' + this.To_Date + ': ' + to_date + '</td>';
      html_data += '<td width="33%"> ' + this.Status + ': ';
      this.statusList.forEach(element => {
        if (element.status_id == this.model['inv_status'])
          html_data += element.status_name;
      });
      html_data += '</td></tr>';

      html_data += '<tr><td width="33%"> ' + this.Invoice_No + ': ' + this.model['invoice_no'] + ' </td>';
      html_data += '<td width="33%"> ' + this.Branch + ': ';
      this.branchList.forEach(element => {
        if (element.branch_id == this.model['branch_id']) {
          html_data += this.applicationConstants.user_branch_info.user_branch_name;
        }
      });
      html_data += '</td>';

      html_data += '<td width="33%"> ' + this.Store + ': ';
      this.storeList.forEach(element => {
        if (element.store_id == this.model['store_id']) {
          html_data += element.store_name;
        }
      });
      html_data += '</td></tr>';

      html_data += '<tr><td width="33%"> ' + this.Customer_Name + ': ' + this.model['customer_name'] + '</td>';
      html_data += '<td width="33%"> ' + this.Mobile + ': ' + this.model['mobile'] + '</td>';
      html_data += '<td width="33%"> ' + this.Amount_Total + ': ' + this.total + ' </td></tr>';

      // html_data += '<tr><td width="33%"> ' + this.Type + ': ';
      // this.typeList.forEach(element => {
      //   if (element.type_id == this.model['inv_type'])
      //     html_data += element.type_name;
      // });
      // html_data += '</td><td width="33%"></td></tr>';
      html_data += '</table>';

      let table = (document.getElementById('invoice_table2') as HTMLTableElement);
      html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
    }
    else
      window.open(this.applicationConstants.generateInvoice + "?no=" + invoice_no, "_blank");
    // window.open(this.applicationConstants.generatePDF + "?type=invoice&no=" + invoice_no, "_blank");
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  // returnInvoice(row) {
  //   this.router.navigate(['sub_menu/1/return_invoice', { 'no': row.invoice_no }]);
  // }

  returnInvoice(row) {

    let dialog_data = [{ 'invoice_no': row.invoice_no, 'invoice_date': row.full_invoice_date }];
    this.returnDateDialogRef = this.dialog.open(ReturnAllDateComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.returnDateDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success') {
          this.utils.returnSaleInvoice(row, result['return_date'], this);
        }
      });

    // if (confirm(this.Ret_All_Msg)) 
    //   this.utils.returnSaleInvoice(row, this);
      
    // if (confirm(this.Ret_All_Msg)) {

    //   let values = [];
    //   //get payment methods:

    //   let query = "SELECT * FROM `inv_payment_method` WHERE `status` = '1' AND `invoice_no` = '" + row.invoice_no + "'";
    //   let obj1 = { cmd: 'getList', query: query };
    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();
    //       let payment_method = data.data['list'];


    //       //get invoice items:
    //       let obj = {
    //         cmd: 'getInvoiceItem', type: 'invoice', invoice_no: row.invoice_no,
    //         for_return: true
    //       };

    //       this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
    //         .subscribe(data => {
    //           this.applicationConstants.appComp.hideBusyCursor();

    //           let invoice_item = [];
    //           if (data.status['type'] == 'success')
    //             invoice_item = data.status['msg'];

    //           console.log(invoice_item);

    //           let return_date = ((new Date()).getFullYear() + "-" + ((new Date()).getMonth() + 1) + "-"
    //             + (new Date()).getDate() + ' ' + (new Date()).getHours() + ':' + (new Date()).getMinutes() +
    //             ':' + (new Date()).getSeconds());


    //           let is_equal_ret = true;
    //           invoice_item.forEach(element => {
    //             if (element.sale_ret_acct_no != invoice_item['0']['sale_ret_acct_no'])
    //               is_equal_ret = false;
    //           });
    //           let ret_sales_acct = '';
    //           if (is_equal_ret)
    //             ret_sales_acct = invoice_item['0']['sale_ret_acct_no'];

    //           //return_invoice:

    //           values.push({
    //             'table_name': 'return_invoice', 'return_invoice_id': '0', 'return_invoice_no': '0', 'invoice_no': row.invoice_no,
    //             'return_date': return_date, 'total': row.total, 'discount': row.discount, 'tax': row.tax, 'tax_acct': row.tax_acct, 'ret_sales_acct': ret_sales_acct,
    //             'payment_method': row.payment_method, 'acct_number': row.acct_number, 'is_paid': row.is_paid, 'flag': 'new', 'key': 'return_invoice_id',
    //             'status': '3', 'comment': '', 'cost_center': row.cost_center, 'branch_id': row.branch_id,
    //             'store_id': row.store_id
    //           });


    //           //return_invoice_item:

    //           invoice_item.forEach(element => {
    //             values.push({
    //               'table_name': 'return_invoice_item', 'return_invoice_no': '', 'invoice_item_id': element.invoice_item_id,
    //               'sub_item_number': element.sub_item_number, 'sub_item_name': element.sub_item_name,
    //               'return_count': element.count, 'price': element.price, 'unit_id': element.unit_id,
    //               'return_tax': element.tax_amount, 'total_price': element.total_price,
    //               'discount': element.discount, 'tax_no': element.tax_no, 'damage': '0',
    //               'damage_reason': '', 'stock_no': element.stock_no, 'return_date': return_date,
    //               'store_id': element.store_id, 'primary_sub_item_number': element.primary_sub_item_number,
    //               'flag': 'new', 'key': 'return_item_id', 'return_item_id': '0',
    //               'primary_quantity': (element.stock_no != '0' ? (Number(element.count) * Number(element.primary_quantity)).toFixed(2) : '0'),
    //               'comment': '', 'sale_ret_acct_no': element.sale_ret_acct_no
    //             });

    //           });

    //           //return_invoice_payment_method:
    //           payment_method.forEach(element => {
    //             values.push({
    //               'table_name': 'ret_inv_payment_method', 'return_invoice_no': '',
    //               'ret_inv_payment_method_id': element.inv_payment_method_id, 'flag': 'new', 'key': 'ret_inv_payment_method_id',
    //               'payment_type_id': element.payment_type_id, 'acct_number': element.acct_number, 'amount': element.amount
    //             });

    //           });

    //           let current_year = new Date().getFullYear();
    //           let prefix = 'RET-' + this.applicationConstants.user_branch_info.user_branch_id + "-" + current_year;

    //           console.log(values);
    //           let obj = { cmd: 'add', values: values, pk: 'return_invoice_no', 
    //             id: 'return_invoice_id', main_table: 'return_invoice', prefix: prefix };

    //           this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //             .subscribe(data => {
    //               this.applicationConstants.appComp.hideBusyCursor();

    //               if (data.status['type'] == 'success') {
    //                 let ret_invoice_no;

    //                 ret_invoice_no = data.status['msg'][0]['number'];

    //                 //To update invoice status and return invoice status to 3 after canceling -- 10-05-2021
    //                 let values1 = [];
    //                 let where = [];
    //                 // values1.push({ 'table_name': this.model['table_name'], 'invoice_no': row.invoice_no, 'flag': 'update', 'key': 'invoice_id', 'status': '3' });
    //                 // values1.push({ 'table_name': 'invoice_item', 'invoice_no': row.invoice_no });
    //                 // values1.push({ 'table_name': 'inv_payment_method', 'invoice_no': row.invoice_no });
    //                 // let obj = { cmd: 'deleteRec', values: values1 };
                    
    //                 // values1.push({ 'table_name': 'return_invoice', 'status': '3' });
    //                 // where.push({'return_invoice_no': ret_invoice_no});

    //                 values1.push({ 'table_name': 'invoice', 'status': '3' });
    //                 where.push({'invoice_no': row.invoice_no});
    //                 let obj1 = { cmd: 'update', values: values1, where: where };

    //                 this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
    //                   .subscribe(data => {
    //                     this.applicationConstants.appComp.hideBusyCursor();
    //                     // console.log(data);
    //                     if (data.status['type'] == 'success') {
    //                       alert(this.Cancel_Invoice_Msg + this.Ret_No_Msg + ret_invoice_no);
    //                       this.search();
    //                     }
    //                     else {
    //                       alert(this.Error_Msg);
    //                     }
    //                   });
    //               }
    //               else
    //                 alert(this.Error_Msg);
    //             });

    //         });

    //     });
    // }
  }

}
